"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWatchRequests = exports.authenticatedPutRequest = exports.authenticatedPostRequest = exports.authenticatedGetRequest = exports.authenticatedDeleteRequest = exports.authenticated = void 0;
exports.deleteEffect = deleteEffect;
exports.deleteRequest = deleteRequest;
exports.effectMap = void 0;
exports.getCurrentClubId = getCurrentClubId;
exports.getEffect = getEffect;
exports.getFileEffect = getFileEffect;
exports.getRequest = getRequest;
exports.postEffect = postEffect;
exports.postRequest = postRequest;
exports.prependClubsUrl = prependClubsUrl;
exports.putEffect = putEffect;
exports.putRequest = putRequest;
exports.setPathApiBase = void 0;
require("whatwg-fetch");
var _fp = _interopRequireDefault(require("lodash/fp"));
var _reduxSaga = require("redux-saga");
var _effects = require("redux-saga/effects");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// import { selectors as authSelectors } from '../reducers/auth'
// import { selectors as clubsSelectors } from '../reducers/clubs'

const authSelectors = {
  getToken: _fp.default.flow(_fp.default.get('auth'), _fp.default.get('token'))
};
const clubsSelectors = {
  getActive: _fp.default.flow(_fp.default.get('router.location.pathname'), _fp.default.split('/'), _fp.default.get(1))
};
let PATH_API_BASE;
const setPathApiBase = p => {
  PATH_API_BASE = p;
};

/**
 * Wrapper around `fetch`.
 *
 * Returns { error } if the `response` is unsuccessful ~ ![200;300)
 * NEVER throws exceptions.
 */
exports.setPathApiBase = setPathApiBase;
function* wrapFetch(url, options) {
  let response = {};
  try {
    response = yield window.fetch(url, options);
  } catch (err) {
    return {
      error: {
        status: 503,
        statusText: 'Service unavailable'
      }
    };
  }
  let json = {};
  if (_fp.default.get(['_bodyBlob', 'type'], response) === 'application/x-md5' || _fp.default.head(_fp.default.get(['headers', 'map', 'content-type'], response)) === 'application/x-md5') {
    try {
      const md5 = yield response.text();
      json = {
        md5
      };
    } catch (err) {
      // eh
    }
  } else {
    try {
      json = yield response.json();
    } catch (err) {
      // eh
    }
  }
  if (response.ok) {
    const token = response.headers.get('X-Auth-Token');
    if (token) {
      return _objectSpread(_objectSpread({}, json), {}, {
        token
      });
    }
    return json;
  }
  if (_fp.default.isEmpty(json)) {
    return {
      error: {
        status: response.status,
        statusText: response.statusText
      }
    };
  }
  return {
    error: {
      status: response.status,
      statusText: response.statusText,
      body: json
    }
  };
}

/**
 * Builds options for the `fetch` function.
 *
 * - Add content type `application/json`
 * - Stringify the `body` if present
 */
const decorateOptions = function () {
  let method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
  let body = arguments.length > 1 ? arguments[1] : undefined;
  let otherHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let loadedAt = arguments.length > 3 ? arguments[3] : undefined;
  let token = arguments.length > 4 ? arguments[4] : undefined;
  let noHeaders = arguments.length > 5 ? arguments[5] : undefined;
  let headers = _objectSpread({
    'Content-Type': 'application/json'
  }, otherHeaders);
  if (token) {
    headers['X-Auth-Token'] = token;
  }
  return _objectSpread({
    method,
    headers: noHeaders ? {} : headers
  }, body ? {
    body: JSON.stringify(body)
  } : {});
};
function getRequest(url) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    body = _ref.body,
    headers = _ref.headers,
    loadedAt = _ref.loadedAt,
    token = _ref.token,
    noHeaders = _ref.noHeaders;
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('get', body, headers, loadedAt, token, noHeaders));
  }();
}
function postRequest(url) {
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    body = _ref2.body,
    headers = _ref2.headers,
    loadedAt = _ref2.loadedAt,
    token = _ref2.token,
    noHeaders = _ref2.noHeaders;
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('post', body, headers, loadedAt, token, noHeaders));
  }();
}
function putRequest(url) {
  let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    body = _ref3.body,
    headers = _ref3.headers,
    loadedAt = _ref3.loadedAt,
    token = _ref3.token,
    noHeaders = _ref3.noHeaders;
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('put', body, headers, loadedAt, token, noHeaders));
  }();
}
function deleteRequest(url) {
  let _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    body = _ref4.body,
    headers = _ref4.headers,
    loadedAt = _ref4.loadedAt,
    token = _ref4.token,
    noHeaders = _ref4.noHeaders;
  return function* () {
    return yield (0, _effects.call)(wrapFetch, url, decorateOptions('delete', body, headers, loadedAt, token, noHeaders));
  }();
}

/**
 * Helper function to build authenticated request functions.
 *
 * @param  {function} asyncRequestFunction - request function
 * @param  {string} token - API token
 * @return {function} request function embedding the token as a header
 */
const authenticated = (asyncRequestFunction, token) => {
  return function subAuthenticated(url) {
    let _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      body = _ref5.body,
      headers = _ref5.headers,
      loadedAt = _ref5.loadedAt,
      noHeaders = _ref5.noHeaders;
    return function* () {
      return yield (0, _effects.call)(asyncRequestFunction, url, {
        body,
        headers,
        loadedAt,
        token,
        noHeaders
      });
    }();
  };
};
exports.authenticated = authenticated;
const authenticatedGetRequest = token => authenticated(getRequest, token);
exports.authenticatedGetRequest = authenticatedGetRequest;
const authenticatedPostRequest = token => authenticated(postRequest, token);
exports.authenticatedPostRequest = authenticatedPostRequest;
const authenticatedPutRequest = token => authenticated(putRequest, token);
exports.authenticatedPutRequest = authenticatedPutRequest;
const authenticatedDeleteRequest = token => authenticated(deleteRequest, token);
exports.authenticatedDeleteRequest = authenticatedDeleteRequest;
const effectMap = exports.effectMap = {
  get: getEffectInternal,
  put: putEffectInternal,
  post: postEffectInternal,
  delete: deleteEffectInternal
};
const createHandleRequest = basePath => {
  const decoratePath = url => {
    return _fp.default.startsWith('http', url) ? url : "".concat(basePath).concat(_fp.default.startsWith('/', url) ? '' : '/').concat(url);
  };
  return function* handleRequest(networkChannel) {
    while (true) {
      const _yield$take = yield (0, _effects.take)(networkChannel),
        outputChan = _yield$take.outputChan,
        _yield$take$request = _yield$take.request,
        type = _yield$take$request.type,
        _yield$take$request$a = _yield$take$request.authenticated,
        authenticated = _yield$take$request$a === void 0 ? true : _yield$take$request$a,
        url = _yield$take$request.url,
        _yield$take$request$o = _yield$take$request.options,
        options = _yield$take$request$o === void 0 ? {} : _yield$take$request$o;

      // Find the corresponding effect to the type of request
      const internalEffect = effectMap[type];

      // If the request is unknown, throw error
      if (!internalEffect) {
        console.warn("Unknown request method: ".concat(type));
        continue;
      }
      const requestEffect = yield (0, _effects.call)(internalEffect, {
        authenticated
      });
      const result = yield (0, _effects.call)(requestEffect, decoratePath(url), options);
      yield (0, _effects.put)(outputChan, result);
      outputChan.close();
    }
  };
};

// scoped channel accessible by watchRequests and requestEffect
let NETWORK_CHANNEL;
const createWatchRequests = basePath => {
  const handleRequest = createHandleRequest(basePath);
  return function* watchRequests() {
    NETWORK_CHANNEL = yield (0, _effects.call)(_reduxSaga.channel, _reduxSaga.buffers.expanding(20));
    for (var i = 0; i < 10; i++) {
      yield (0, _effects.fork)(handleRequest, NETWORK_CHANNEL);
    }
  };
};
exports.createWatchRequests = createWatchRequests;
function* requestEffect(type, request) {
  // request is an object with these keys:
  //
  // - authenticated (bool)
  // - url (string)
  // - options (object)
  //
  const outputChan = (0, _reduxSaga.channel)();
  const requestWithType = _objectSpread(_objectSpread({}, request), {}, {
    type
  });
  yield (0, _effects.put)(NETWORK_CHANNEL, {
    outputChan,
    request: requestWithType
  });
  return outputChan;
}
function* getEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'get', request);
}
function* putEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'put', request);
}
function* postEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'post', request);
}
function* deleteEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'delete', request);
}
function* getFileEffect(request) {
  return yield (0, _effects.call)(requestEffect, 'get/FILE', request);
}

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

function* requestEffectInternal(requestFunction) {
  const token = yield (0, _effects.select)(authSelectors.getToken);
  return yield (0, _effects.call)(requestFunction, token);
}
function getEffectInternal() {
  let _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref6$authenticated = _ref6.authenticated,
    authenticated = _ref6$authenticated === void 0 ? true : _ref6$authenticated;
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedGetRequest);
    }
    return getRequest;
  }();
}
function postEffectInternal() {
  let _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$authenticated = _ref7.authenticated,
    authenticated = _ref7$authenticated === void 0 ? true : _ref7$authenticated;
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedPostRequest);
    }
    return postRequest;
  }();
}
function putEffectInternal() {
  let _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref8$authenticated = _ref8.authenticated,
    authenticated = _ref8$authenticated === void 0 ? true : _ref8$authenticated;
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedPutRequest);
    }
    return putRequest;
  }();
}
function deleteEffectInternal() {
  let _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref9$authenticated = _ref9.authenticated,
    authenticated = _ref9$authenticated === void 0 ? true : _ref9$authenticated;
  return function* () {
    if (authenticated) {
      return yield (0, _effects.call)(requestEffectInternal, authenticatedDeleteRequest);
    }
    return deleteRequest;
  }();
}
function* getCurrentClubId() {
  const path = yield (0, _effects.select)(_fp.default.get('router.location.pathname'));
  let clubId = _fp.default.get(1, _fp.default.split('/', path));
  if (!_fp.default.isInteger(_fp.default.parseInt(10, clubId))) {
    clubId = yield (0, _effects.select)(clubsSelectors.getActive);
  }
  return clubId;
}
function* prependClubsUrl(url, optionalClubId) {
  const clubId = optionalClubId || (yield getCurrentClubId());
  if (url) {
    return "clubs/".concat(clubId, "/").concat(url);
  }
  return "clubs/".concat(clubId);
}